import React from 'react';
import styles from './OrderStatusBadge.module.css';

export type OrderStatus = 'Submitted' | 'Approved' | 'Draft' | 'In Transit' | 'Delivered' | 'Pending';

interface OrderStatusBadgeProps {
  status: OrderStatus;
}

const key = (s: string) => s.replace(/\s+/g, '').toLowerCase();

export const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({ status }) => {
  return <span className={`${styles.badge} ${styles[key(status)]}`}>{status}</span>;
};
